import {
  detectUserLocation,
  getLanguageFromLocation,
} from "@/utils/locationDetection";
import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

// 자동 언어 감지 및 리다이렉트 컴포넌트
export default function LanguageRedirect() {
  const [redirectPath, setRedirectPath] = useState<string | null>(null);
  console.log("redirect");
  useEffect(() => {
    const detectLanguage = async () => {
      // 1. URL 파라미터로 언어 강제 설정 확인
      const urlParams = new URLSearchParams(window.location.search);
      console.log(urlParams);
      const forcedLang = urlParams.get("lang");
      if (forcedLang === "ko" || forcedLang === "kr") {
        localStorage.setItem("preferred-language", "ko");
        console.log("forcedLang");
        setRedirectPath("/kr");
        return;
      } else if (forcedLang === "en") {
        localStorage.setItem("preferred-language", "en");
        console.log("forcedLang");
        setRedirectPath("/en");
        return;
      }

      // 2. localStorage에서 이전 언어 선택 확인
      const savedLanguage = localStorage.getItem("preferred-language");
      console.log(savedLanguage);
      if (savedLanguage && (savedLanguage === "ko" || savedLanguage === "en")) {
        console.log("savedLanguage");
        setRedirectPath(savedLanguage === "ko" ? "/kr" : "/en");
        return;
      }

      // 3. IP 기반 위치 감지 시도
      try {
        const location = await detectUserLocation();
        if (location) {
          const languageFromLocation = getLanguageFromLocation(location);
          localStorage.setItem("preferred-language", languageFromLocation);
          setRedirectPath(languageFromLocation === "ko" ? "/kr" : "/en");
          return;
        }
      } catch (error) {
        console.warn(
          "Location-based detection failed, falling back to browser language"
        );
      }

      // 4. 브라우저 언어 감지 (fallback)
      const browserLanguage =
        navigator.language || navigator.languages?.[0] || "en";
      const languageCode = browserLanguage.split("-")[0].toLowerCase();

      // 5. 한국어 관련 언어코드들 체크
      const koreanLanguages = ["ko", "kr"];

      if (koreanLanguages.includes(languageCode)) {
        localStorage.setItem("preferred-language", "ko");
        setRedirectPath("/kr");
      } else {
        // 기본값은 영어
        localStorage.setItem("preferred-language", "en");
        setRedirectPath("/en");
      }
    };

    detectLanguage();
  }, []);

  // 리다이렉트 경로가 결정되면 Navigate 컴포넌트로 리다이렉트
  if (redirectPath) {
    return <Navigate to={redirectPath} replace />;
  }

  // 로딩 중일 때는 아무것도 렌더링하지 않음
  return null;
}
